<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card>
          <l-data-table
            ref="personalConfigList"
            :headers="orgHeader"
            :get-data-func="getPersonalConfigList"
            @click:row="getDetails($event.item)"
            clickable
            hide-title-search
            selectable
            v-model="selected"
            :title-text="'个人配置列表'">
            <template slot="title-action">
              <v-menu left>
                <v-btn
                  icon
                  slot="activator"
                >
                  <v-icon>$vuetify.icons.more</v-icon>
                </v-btn>
                <v-list dense>
                  <v-list-tile
                    @click="deleteConfigs(selected)"
                  >
                    <v-list-tile-title class="pr-1">
                      <v-flex layout align-center>
                        <v-icon class="pr-3">$vuetify.icons.delete</v-icon>
                        <span>批量删除</span>
                      </v-flex>
                    </v-list-tile-title>
                  </v-list-tile>
                  <!--<v-list-tile @click="">-->
                  <!--<v-list-tile-title>导出</v-list-tile-title>-->
                  <!--</v-list-tile>-->
                </v-list>
              </v-menu>
            </template>
            <template slot="row-action" slot-scope="{item}">
              <td @click.stop class="px-0 mx-0 text-xs-center">
                <v-tooltip left>
                  <v-btn @click="deleteConfigConfirm(item)" slot="activator" icon>
                    <v-icon small>$vuetify.icons.delete</v-icon>
                  </v-btn>
                  <span>删除配置</span>
                </v-tooltip>
              </td>
            </template>
          </l-data-table>
          <l-fixed-btn
            @click="addPersonalConfig"
            icon="$vuetify.icons.add"
          ></l-fixed-btn>
        </v-card>
      </v-flex>
    </v-layout>
  </l-layout>
</template>
<script>
import {time} from '../../../../ladmin/utils/time'
export default{
  name: 'PersonPersonalConfigList',
  props: {
    orderType: {
      type: String,
      default: 'order_letter'
    }
  },
  data () {
    return {
      orgHeader: [
        {text: '用户名称', value: 'name', align: 'left', sortable: false},
        {text: '用户账号', value: 'loginId', align: 'left', sortable: false},
        {text: '创建时间', value: 'creationTime', align: 'left', f: (v) => time.stringify(v)},
        {text: '', value: '', align: 'left'}
      ],
      index: 1,
      selected:[]
    }
  },
  created () {
  },
  methods: {
    async getPersonalConfigList ({pagination, sortStack, filterItems, search}) {
      let res = await this.$store.dispatch('personReservationConfig/getConfigList', {pagination, orderType: this.orderType, ownerType: 'object'})
      console.log(res)
      if (res.data.status === 1) {
        let items = []
        for (let i = 0; i < res.data.data.content.length; i++) {
          var obj = res.data.data.content[i]
          obj.name = obj.user.name
          obj.loginId = obj.user.loginId
          obj.creationTime = obj.vehicle.creationTime
          obj.id = obj.user.id
          items.push(obj)
        }
        return {items: items, amount: res.data.data.totalElements}
      }
      else {
        this.$L.alert('error', {message: '查询配置信息列表错误，原因：' + res.data.msg})
      }
    },
    addPersonalConfig () {
      this.$router.push({
        name: 'PersonNewPersonalConfig',
        query: {
          ownerId: 'newPersonalConfig',
          orderType: this.orderType,
          status: 'new',
          ownerType: 'object',
        }
      })
      this.index++
    },
    getDetails (item) {
      // console.log(item)
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'PersonConfigDetail',
          query: {
            ownerId: item.user.id,
            orderType: this.orderType,
            status: 'readonly',
            ownerType: 'object'
          }
        })
      }
    },
    async deleteConfigConfirm (item) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除该配置？',
      })
      if (res) {
        try {
          await this.deleteConfigs(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteConfigs (items) {
      let params = []
      if (items instanceof Array) {
        // alert('1')
        for (let i = 0; i < items.length; i++) {
          params.push(items[i].vehicle.id)
        }
      }
      else {
        params.push(items.vehicle.id)
      }
      let config = {
        'ids': params
      }
      // console.log(config)
      let res = await this.$store.dispatch('personReservationConfig/deleteConfigs', config)
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '删除成功'})
        this.$refs.personalConfigList.refresh()
      }
      else {
        this.$L.alert('error', {message: '删除失败原因为：' + res.data.msg})
      }
    }
  }
}
</script>
